export const CONTEST_ACTIONS = {
    // --- UI ---
    SET_FETCHING: 'SET_FETCHING',
    SET_LOADING: 'SET_LOADING',
    SET_ERROR: 'SET_ERROR',
    SET_FORM_ERROR: 'SET_FORM_ERROR',
    SET_STEP: 'SET_STEP',

    // --- DATA ---
    INIT_SUCCESS: 'INIT_SUCCESS',

    // USER
    UPDATE_USER_INFOS: 'UPDATE_USER_INFOS',
    UPDATE_RUGBY_BET: 'UPDATE_RUGBY_BET',
    SET_USER_REWARD: 'SET_USER_REWARD',
    // Referral resolution of the ?ref= code, and whether an attribution actually happened at sign-up.
    SET_REFERRAL: 'SET_REFERRAL',
    SET_REFERRAL_APPLIED: 'SET_REFERRAL_APPLIED',
    SET_HALF_TIME_REWARD: 'SET_HALF_TIME_REWARD',
    SET_PENALTY_REWARD: 'SET_PENALTY_REWARD',
    SET_PENALTY_STATE: 'SET_PENALTY_STATE',
    SET_PENALTY_BOARD: 'SET_PENALTY_BOARD',

    // CALCULATIONS
    UPDATE_CALCULATIONS: 'UPDATE_CALCULATIONS',

    // --- LIVE & SSE ---
    LIVE_MATCH_UPDATE: 'LIVE_MATCH_UPDATE',
    LIVE_PARTICIPANT_JOINED: 'LIVE_PARTICIPANT_JOINED',

    UPDATE_LEADERBOARD: 'UPDATE_LEADERBOARD',

    // --- OVERLAYS ---
    SET_GOAL_OVERLAY: 'SET_GOAL_OVERLAY',
    SET_QR_OVERLAY: 'SET_QR_OVERLAY',
    SET_SELECTED_PLAYER: 'SET_SELECTED_PLAYER'
};